import { ReactNode } from "react";
import Header from "./common/header";
import Sidebar from "./common/sidebar";

type Props = {
  children: ReactNode;
};

function MainLayout({ children }: Props) {
  return (
    <div className="page-main">
      <Header />
      <div className="jumps-prevent"  style={{paddingTop: "74px"}}></div>
      <Sidebar />
      {children}
    </div>
  );
}

export default MainLayout;
